import { useEffect, useState } from "react";

const usePageSize = () => {
  const getView = () => {
    const width = window.innerWidth;

    if (width < 768) return "mobile"; // Mobile
    if (width >= 768 && width < 1100) return "tab"; // Tablet
    return "pos"; // POS Machine / Desktop
  };

  const [view, setView] = useState(getView());

  useEffect(() => {
    const handleResize = () => {
      window.requestAnimationFrame(() => {
        setView(getView());
      });
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return view;
};

export default usePageSize;
